import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import profile from '../utils/images/profile.jpg';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '../context/ThemeContext';
import {
  Collapse,
  Navbar as BsNavbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  Button,
  Container,
} from 'reactstrap';
import '../Navbar.css';

const NavigationBar = () => {
  const { theme, toggleTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const toggle = () => setIsOpen(!isOpen);

  const getNavLinkClassName = (headerName) => {
    const isActive = location.pathname.split('/')[1] === headerName.split('/')[0];
    return `nav-link ${isActive ? 'active' : ''} text-${theme === 'dark' ? 'light' : 'dark'}`;
  };

  // Handle keyboard navigation for mobile menu
  const handleKeyDown = (event) => {
    if (event.key === 'Escape' && isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <BsNavbar
      color={theme === 'dark' ? 'dark' : 'light'}
      dark={theme === 'dark'}
      light={theme !== 'dark'}
      expand="md"
      className="shadow-sm py-2"
      style={{
        backgroundColor: 'var(--navbar-bg)',
        color: 'var(--navbar-text)',
        transition: 'background-color 0.3s ease, color 0.3s ease',
      }}
      role="navigation"
      aria-label="Main navigation"
      onKeyDown={handleKeyDown}
    >
      <Container>
        <NavbarBrand tag="div" className="d-flex align-items-center me-auto">
          <Link
            to="/"
            className="d-flex align-items-center text-decoration-none"
            aria-label="Go to homepage"
          >
            <img
              alt="Nikhil Bhatt profile picture"
              src={profile}
              style={{
                height: 32,
                width: 32,
                borderRadius: '50%',
                marginRight: 8,
                border: `2px solid var(${theme === 'dark' ? '--color-primary' : '--color-primary'})`,
              }}
              className="d-inline-block align-top"
            />
            <span
              className="d-none d-md-inline fw-bold"
              style={{ color: 'var(--text-primary)' }}
              aria-hidden="true"
            >
              Nikhil Bhatt
            </span>
          </Link>
        </NavbarBrand>

        <NavbarToggler
          onClick={toggle}
          className="me-2"
          aria-label={isOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={isOpen}
          aria-controls="navbarNav"
          style={{
            border: 'none',
            padding: '0.5rem',
            borderRadius: '0.375rem',
            transition: 'all 0.2s ease',
            minWidth: '44px',
            minHeight: '44px',
          }}
        />

        <Collapse
          isOpen={isOpen}
          navbar
          className="justify-content-between"
          id="navbarNav"
          role="menubar"
        >
          <Nav navbar className="mx-auto mx-md-0" role="menubar">
            <NavItem className="mx-2" role="none">
              <Link
                to="/"
                className={getNavLinkClassName('/')}
                onClick={() => setIsOpen(false)}
                role="menuitem"
                aria-current={location.pathname === '/' ? 'page' : undefined}
              >
                Home
              </Link>
            </NavItem>
            <NavItem className="mx-2" role="none">
              <Link
                to="/blogs"
                className={getNavLinkClassName('blogs')}
                onClick={() => setIsOpen(false)}
                role="menuitem"
                aria-current={location.pathname.startsWith('/blogs') ? 'page' : undefined}
              >
                Blog
              </Link>
            </NavItem>
            <NavItem className="mx-2" role="none">
              <Link
                to="/projects"
                className={getNavLinkClassName('projects')}
                onClick={() => setIsOpen(false)}
                role="menuitem"
                aria-current={location.pathname === '/projects' ? 'page' : undefined}
              >
                Projects
              </Link>
            </NavItem>
            <NavItem className="mx-2" role="none">
              <Link
                to="/work"
                className={getNavLinkClassName('work')}
                onClick={() => setIsOpen(false)}
                role="menuitem"
                aria-current={location.pathname === '/work' ? 'page' : undefined}
              >
                Work
              </Link>
            </NavItem>
            <NavItem className="mx-2" role="none">
              <Link
                to="/contact"
                className={getNavLinkClassName('contact')}
                onClick={() => setIsOpen(false)}
                role="menuitem"
                aria-current={location.pathname === '/contact' ? 'page' : undefined}
              >
                Contact
              </Link>
            </NavItem>
          </Nav>

          <div className="d-flex align-items-center mt-2 mt-md-0">
            <Button
              color="link"
              onClick={() => {
                toggleTheme();
                setIsOpen(false);
              }}
              className="text-decoration-none p-2"
              aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
              style={{
                minWidth: '44px',
                minHeight: '44px',
                borderRadius: '0.375rem',
                border: '2px solid transparent',
              }}
              onFocus={(e) => {
                e.target.style.borderColor = 'var(--color-primary)';
                e.target.style.outline = 'none';
              }}
              onBlur={(e) => {
                e.target.style.borderColor = 'transparent';
              }}
            >
              <FontAwesomeIcon
                icon={theme === 'dark' ? faSun : faMoon}
                style={{
                  color: theme === 'dark' ? 'var(--warning)' : 'var(--text-primary)',
                  fontSize: '1rem',
                  transition: 'color 0.3s ease',
                }}
                aria-hidden="true"
              />
            </Button>
          </div>
        </Collapse>
      </Container>
    </BsNavbar>
  );
};

export default NavigationBar;
